<template>
  <div
    :class="['modal-wrapper', { ['drag-overlay']: dragOver }]"
    ref="fileform"
  >
    <div :class="['static', { dragOver: dragOver }]">
      <div class="modal drag-mock" v-show="dragOver">
        <files-icon width="50" height="65" fillColor="#81869E"></files-icon>
        <p v-html="$t('dashboard-modal-drag-and-drop')"></p>
      </div>
      <div v-show="!dragOver">
        <upload-view
          v-if="showUploadView"
          :determineDragAndDropCapable="determineDragAndDropCapable"
          @handleFilesUpload="handleFilesUpload"
          @closeModalclearExchangeDraft="closeModalclearExchangeDraft"
          @filesChoosenAndUploaded="updateChoosenFiles"
          @closeUploadModal="closeUploadModal"
        >
        </upload-view>
        <share-view
          v-else
          :exchangeCopy="exchangeCopy"
          @handleFilesUpload="handleFilesUpload"
          @closeModalclearExchangeDraft="closeModalclearExchangeDraft"
          @clearExchangeCopy="clearExchangeCopy"
          @closeUploadModal="closeUploadModal"
        >
        </share-view>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import UploadView from "@/views/modules/dashboard/components/file-upload/Upload";
import ShareView from "@/views/modules/dashboard/components/file-upload/Share";
import FilesIcon from "@/components/icons/FilesIcon";
import { dragAndDrop } from "@/mixins/dragAndDrop";

export default {
  name: "UploadModal",
  mixins: [dragAndDrop],
  components: {
    UploadView,
    ShareView,
    FilesIcon
  },
  props: {
    exchangeCopy: {
      required: true
    }
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapState("exchange", [
      "choosenFiles",
      "exchangeCopyChoosenFiles",
      "exchange"
    ]),
    showUploadView() {
      if (this.exchangeCopy) {
        return !this.exchangeCopyChoosenFiles.some(
          item => item && item.filename !== null
        );
      } else {
        return !this.choosenFiles.some(item => item && item.filename !== null);
      }
    }
  },
  methods: {
    ...mapActions("common", ["setLoading", "showModal", "closeUploadModal"]),
    ...mapActions("exchange", [
      "setChoosenFiles",
      "updateExchangeFiles",
      "updateChoosenFiles"
    ]),
    handleFilesUpload(files) {
      this.setChoosenFiles(files);
      let fileList = [];

      for (let i = 0; i < this.choosenFiles.length; i++) {
        if (this.choosenFiles[i]) {
          const file = {
            filename: this.choosenFiles[i].name,
            size: this.choosenFiles[i].size
          };
          fileList.push(file);
        }
      }

      this.updateExchangeFiles(fileList);
    },
    closeModalclearExchangeDraft() {
      this.$emit("closeModalclearExchangeDraft");
    },
    clearExchangeCopy() {
      this.$emit("clearExchangeCopy");
    }
  },
  mounted() {
    this.setLoading(true);

    this.$store
      .dispatch("exchange/getParticipantList", this.user)
      .then(() => {
        this.setLoading(false);
      })
      .catch(err => {
        this.setLoading(false);
        this.showModal({
          title: err.errorCode
        });
      });

    if (!this.exchangeCopy) {
      this.$store
        .dispatch("exchange/createExchange")
        .then(() => {
          this.setLoading(false);
        })
        .catch(err => {
          this.setLoading(false);
          this.showModal({
            title: err.errorCode
          });
        });
    }
  }
};
</script>

<style lang="scss">
@import "../../../../../assets/styles/datepicker";
@import "../../../../../assets/styles/tags-input";
</style>

<style scoped lang="scss">
@import "../../../../../assets/styles/variables";

.modal-wrapper {
  z-index: 3;
  /deep/ .modal {
    display: flex;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    position: absolute;
    width: 50%;
    text-align: center;
    border-radius: 16px;
  }
  /deep/ .form-group {
    margin: 10px 0;
    button:not(:last-child) {
      margin-right: 10px;
    }
  }
}

/deep/ .upload-file-wrapper {
  input[type="file"] {
    visibility: hidden;
    z-index: -1;
    position: absolute;
  }
}

/deep/ .static .upload {
  pointer-events: auto;
}

.dragOver {
  pointer-events: none;
}

.drag-mock {
  color: $placeholder-color;
  flex-direction: column;
  align-items: center;
}

.drag-overlay {
  /deep/ .modal {
    justify-content: center;
    color: $placeholder-color;
    background: white;
  }
}
</style>
